/**
 * form-serialize v0.2.1
 *
 * Copyright 2017, Dimitar Ivanov (https://zinoui.com/)
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 */
 function form_serialize(form) {
  if (!form || form.nodeName !== "FORM") {
    return;
  }
  var i, j, q = [];
  for (i = form.elements.length - 1; i >= 0; i = i - 1) {
    if (form.elements[i].name === "") {
      continue;
    }
    switch (form.elements[i].nodeName) {
    case 'INPUT':
      switch (form.elements[i].type) {
      case 'text':
      case 'hidden':
      case 'button':
      case 'reset':
      case 'submit':
      case 'color':
      case 'date':
      case 'datetime-local':
      case 'email':
      case 'month':
      case 'number':
      case 'range':
      case 'search':
      case 'tel':
      case 'time':
      case 'url':
      case 'week':
        if (form.elements[i].value && form.elements[i].value.length > 0) {
          q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
        }
        break;
      case 'checkbox':
      case 'radio':
        if (form.elements[i].checked && form.elements[i].value && form.elements[i].value.length > 0) {
          q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
        }
        break;
      case 'file':
        break;
      }
      break;
    case 'TEXTAREA':
      q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
      break;
    case 'SELECT':
      switch (form.elements[i].type) {
      case 'select-one':
        q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
        break;
      case 'select-multiple':
        for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
          if (form.elements[i].options[j].selected) {
            q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].options[j].value));
          }
        }
        break;
      }
      break;
    case 'BUTTON':
      switch (form.elements[i].type) {
      case 'reset':
      case 'submit':
      case 'button':
        q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
        break;
      }
      break;
    }
  }
  return q.join("&");
}
